import { HttpHelper, HttpServiceParams } from '@ppvrbh/merchant-frontend-core';

const BASE_URL = 'v1/merchant/company-admin/menus-modifier-group';

class ModifierGroupServiceClass {
  getMenuModifierGroup = (params?: HttpServiceParams<{ page?: number; limit?: number; keyword?: string }>) => {
    const searchParams = new URLSearchParams();
    if (params?.data?.page !== undefined) {
        searchParams.append('page', String(params.data.page));
    }
    if (params?.data?.limit !== undefined) {
        searchParams.append('limit', String(params.data.limit));
    }
    if (params?.data?.keyword) {
        searchParams.append('keyword', params.data.keyword);
    }
    const query = searchParams.toString() ? '?' + searchParams.toString() : '';
    return HttpHelper.get({
      url: BASE_URL + '/landing' + query,
    });
  }

  createMenuModifierGroup = (params?: HttpServiceParams<{
    menuModifierGroupName: string;
    menuModifierGroupNameEN?: string;
    menuModifierGroupType: number;
    menuModifierGroupItems: number[];
    menuModifierGroupMax?: number;
  }>) => {
    return HttpHelper.post({
      url: BASE_URL,
      data: params?.data,
    });
  }

  updateMenuModifierGroup = (params?: HttpServiceParams<{
    menuModifierGroupId: number;
    menuModifierGroupName: string;
    menuModifierGroupNameEN?: string;
    menuModifierGroupType: number;
    menuModifierGroupItems: number[];
    menuModifierGroupMax?: number;
  }>) => {
    return HttpHelper.patch({
      url: BASE_URL,
      data: params?.data,
    });
  }

  updateSequenceMenuModifierGroup = (params?: HttpServiceParams<{ 
    modifierGroups: { menuModifierGroupId: number; menuModifierGroupSequence: number }[] 
  }>) => {
    return HttpHelper.patch({
      url: `${BASE_URL}/sequence`,
      data: params?.data?.modifierGroups ,
    });
  }

  deleteMenuModifierGroup = (params?: HttpServiceParams<{ id: number }>) => {
    return HttpHelper.post({
      url: `${BASE_URL}/remove`,
      data: { menuModifierGroupId: params?.data?.id },
    });
  }
}

export const ModifierGroupService = new ModifierGroupServiceClass();
